import * as workSessionsApi from '../../api/work-sessions';

export const CHECK_IN = 'CHECK_IN';
export const CHECK_IN_PENDING = 'CHECK_IN_PENDING';
export const CHECK_IN_FULFILLED = 'CHECK_IN_FULFILLED';
export const CHECK_IN_REJECTED = 'CHECK_IN_REJECTED';

export const FETCH_WORK_SESSIONS = 'FETCH_WORK_SESSIONS';
export const FETCH_WORK_SESSIONS_PENDING = 'FETCH_WORK_SESSIONS_PENDING';
export const FETCH_WORK_SESSIONS_FULFILLED = 'FETCH_WORK_SESSIONS_FULFILLED';
export const FETCH_WORK_SESSIONS_REJECTED = 'FETCH_WORK_SESSIONS_REJECTED';

export const FETCH_WORK_SESSIONS_TABLE = 'FETCH_WORK_SESSIONS_TABLE';
export const FETCH_WORK_SESSIONS_TABLE_PENDING = 'FETCH_WORK_SESSIONS_TABLE_PENDING';
export const FETCH_WORK_SESSIONS_TABLE_FULFILLED = 'FETCH_WORK_SESSIONS_TABLE_FULFILLED';
export const FETCH_WORK_SESSIONS_TABLE_REJECTED = 'FETCH_WORK_SESSIONS_TABLE_REJECTED';

export const checkIn = (sessionType: 'remote' | 'remote_sick' | 'sick' | 'business_trip', date?: string) => ({
  type: CHECK_IN,
  payload: workSessionsApi.checkIn(sessionType, date)
});

export const fetchWorkSessions = (startDate?: string, endDate?: string, userId?: number) => ({
  type: FETCH_WORK_SESSIONS,
  payload: workSessionsApi.getWorkSessions(startDate, endDate, userId)
});

export const fetchWorkSessionsTable = (startDate?: string, endDate?: string) => ({
  type: FETCH_WORK_SESSIONS_TABLE,
  payload: workSessionsApi.getWorkSessionsTable(startDate, endDate)
});
